import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import LandingPage from './views/LandingPage';
import OurEventPage from './views/OurEventPage';
import OurHousePage from './views/OurHousePage';
import OurLearningPage from './views/OurLearningPage';
import WorkPage from './views/WorkPage';
import { LanguageProvider } from './contexts/LanguageContext';
import ProductsIndexPage from './features/products/pages/ProductsIndexPage';
import ProductDetailPage from './features/products/pages/ProductDetailPage';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Routes>
        {/* Main Landing Page */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/learning" element={<OurLearningPage />} />

        {/* Grouped Routes under /product */}
        <Route path="/product">
          <Route path="our-event" element={<OurEventPage />} />
          <Route path="our-house" element={<OurHousePage />} />
          <Route path="our-learning" element={<Navigate to="/learning" replace />} />
        </Route>

        <Route path="/products">
          <Route index element={<ProductsIndexPage />} />
          <Route path=":slug" element={<ProductDetailPage />} />
        </Route>
      </Routes>
    </LanguageProvider>
  );
};

export default App;
